/**
 * Body editor for the and_combine step: create-vs-into-existing target
 * toggle, target name (free input or existing-field slot), and the drop
 * zone for the yes/no fields AND'd together.
 */
import React from "react"
import { Radio } from "antd"
import type { RadioChangeEvent } from "antd"
import { BuilderDropZone } from "shared/ui/Builder"
import { QueryBuilderStore } from "stores/queryBuilderStore"
import { AndCombineStep } from "types/queryBuilder.types"
import SingleFieldSlot from "../SingleFieldSlot.component"
import { StepBodyProps } from "./stepBodyProps"

export interface AndCombineStepBodyProps
  extends StepBodyProps<AndCombineStep> {
  renameStep: QueryBuilderStore["renameTransformStep"]
  setMode: QueryBuilderStore["setStepMode"]
  onAddSource: (variable: string) => void
  onRemoveSource: (variable: string) => void
}

const AndCombineStepBody: React.FC<AndCombineStepBodyProps> = ({
  step,
  renameStep,
  setMode,
  onAddSource,
  onRemoveSource,
}) => (
  <>
    <div className="qc-step__field-row">
      <span className="qc-step__field-label">Target:</span>
      <Radio.Group
        value={step.mode}
        onChange={(e: RadioChangeEvent) => setMode(step.id, e.target.value)}
        size="small"
      >
        <Radio.Button value="create">Create new field</Radio.Button>
        <Radio.Button value="into_existing">AND into existing</Radio.Button>
      </Radio.Group>
    </div>
    {step.mode === "create" ? (
      <input
        className="qc-recodes__name qc-mono"
        type="text"
        value={step.name}
        onChange={(e) => renameStep(step.id, e.target.value)}
        placeholder="New variable name (use // for nesting)"
        aria-label="Variable name"
      />
    ) : (
      <div className="qc-step__field-row">
        <span className="qc-step__field-label">Existing field:</span>
        <SingleFieldSlot
          value={step.name}
          onChange={(v) => renameStep(step.id, v)}
          placeholder="Drag the existing field to AND into"
        />
      </div>
    )}
    <BuilderDropZone
      label="Fields to AND together"
      variables={step.sources}
      onAdd={onAddSource}
      onRemove={onRemoveSource}
      emptyHint="Drag yes/no fields. The result is true only if all are true."
    />
  </>
)

export default AndCombineStepBody
